
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd","stroke":"#7C7C7C","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M7.134 8.695L5 9l.305-2.134 5.487-5.487a1.293 1.293 0 011.829 1.829L7.134 8.695zM10 3l1 1"}}),_c('path',{attrs:{"d":"M10 8.5v3.75a.75.75 0 01-.75.75h-7.5a.75.75 0 01-.75-.75v-7.5A.75.75 0 011.75 4H5.5"}})])])
          )
        }
      }
    